// Module
var code = "<span class=\"glyphicon glyphicon-info-sign earlier-then ng-invalid error-message-tooltip\" tooltip-placement=\"tooltipPlacement\" tooltip-html-unsafe=\"{{validationEarlierThenMessage}}\" tooltip-append-to-body=\"true\" ng-hide=\"earlierThenValid\"></span>";
// Exports
module.exports = code;